module.exports = __webpack_public_path__ + "img/provider.bf794835.png";